export default "__VITE_ASSET__Bh0DBysp__"